import React from "react";
import { Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const statusMap = {
    "pending": "warning",
    "waiting for offer": "info",
    "offer accepted": "success",
    "pickup progress": "secondary",
    "dropoff progress": "primary",
    "completed": "#4CAF50", // Custom hex
    "cancelled": "error",
    "scheduled": "teal" // HTML color name works in style, or use hex
};

const StatusButton = ({ status, isSelected, onClick }) => {
    const theme = useTheme();
    const name = status?.name?.toLowerCase() || "";

    // Resolve color
    let colorValue = theme.palette.primary.main;

    const matchKey = Object.keys(statusMap).find(key => name.includes(key));
    if (matchKey) {
        const value = statusMap[matchKey];
        if (value.startsWith("#") || value === "teal") {
            colorValue = value;
        } else if (theme.palette[value]) {
            colorValue = theme.palette[value].main;
        }
    }

    const buttonStyles = {
        color: isSelected ? "white" : "black",
        borderColor: isSelected ? "transparent" : colorValue,
        backgroundColor: isSelected ? colorValue : "transparent",
    };

    return (
        <Button
            variant={isSelected ? "contained" : "outlined"}
            onClick={onClick}
            style={buttonStyles}
            sx={{
                "&:hover": {
                    borderColor: isSelected ? "transparent" : colorValue,
                    backgroundColor: isSelected ? colorValue : "rgba(0, 0, 0, 0.04)",
                    color: isSelected ? "white" : "black",
                    opacity: 0.9
                },
                // Fallback or override
                borderColor: isSelected ? "transparent" : colorValue,
            }}
        >
            {status?.name} ({status?.order_count})
        </Button>
    );
};

export default StatusButton;
